<template>
  <master-main
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('boxinspection.quality_categories_defects')}.pdf`,
        paramMethod: 'POST',
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('boxinspection.quality_categories_defects')}.xlsx`,
        paramMethod: 'POST',
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @refresh="refresh"
    :showSubcategories="true"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
  </master-main>
</template>
<script>
import DefectGroupsTable from 'src/views/Pages/Dashboard/Quality/BoxInspection/DefectGroups/defect-groups-table.js';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '65%' },
    };
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
  computed: {
    getModuleRoute() {
      return 'quality/defectgroups';
    },
    buildTableProperties() {
      return {
        tableColumns: [...DefectGroupsTable().tableColumns],
        model: 'defectgroups',
        widthColumnStatus: 160,
        widthOperations: 110,
        effectTags: 'dark',
      };
    },
  },
};
</script>
